import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/index.scss";
import App from "./App";

ReactDOM.createRoot(
    document.querySelector("#root")
).render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
